export default [
    {
        path: "/unidades-consumidoras",
        name: "Unidades Consumidoras",
        component: () => import("../views/UnidadesConsumidoras"),
        meta: { requiresAuth: true },
    },
]